// extracted by mini-css-extract-plugin
module.exports = {"Container":"modal-dialog-footer_Container__NdCEd"};